import React from "react";
import { STPaper } from "@src/Components/Ui/STPaperOverflow";
import { Table, TableHead, TableCell, TableRow, TableBody } from "@material-ui/core";
import { STTableHeadTypography } from "@src/Components/Ui/STTableHeadTypography";
import { Values } from "@src/Tools/Values";
import LocationTableItem from "./LocationTableItem/LocationTableItem";
import { Location } from "@src/Interfaces/Entity/Location";

interface IProps {
  locations: Location[];
  onEditButtonClick: (location: Location) => void;
}

export default class LocationsTable extends React.Component<IProps> {
  render() {
    return (
      <STPaper elevation={2}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <STTableHeadTypography>{Values.getLocalizationValue("name")}</STTableHeadTypography>
              </TableCell>
              <TableCell>
                <STTableHeadTypography>{Values.getLocalizationValue("description")}</STTableHeadTypography>
              </TableCell>
              <TableCell>
                <STTableHeadTypography>{Values.getLocalizationValue("type")}</STTableHeadTypography>
              </TableCell>
              <TableCell />
              <TableCell align="right" />
            </TableRow>
          </TableHead>
          <TableBody>
            {this.props.locations.map((location: Location) => (
                <LocationTableItem
                    key={location.id}
                    location={location}
                    onEditButtonClick={this.props.onEditButtonClick}
                />
            ))}
          </TableBody>
        </Table>
      </STPaper>
    );
  }
}
